import React from "react";
import { GeoView } from "../risk/GeoView";
import Timeline from "../risk/bottombar/Timeline";
import { useForecastTime, } from "../../features/surface/surfaceSlice";
import UserProfileElement from "../risk/UserProfileElement";
import TripDrawerElement from "../tripSidebar/TripDrawerElement";
import { useRiskViewerState } from "../../features/riskViewer/riskViewerSlice";
import { useRouteMetadata } from "./useRouteMetadata";
import { useLatestForecast } from "./useLatestForecast";
import { useFetchSurfaces } from "./useFetchSurfaces";
import { isDataStale } from "./RiskViewerUtils";
import { useWindowSize } from "./useWindowSize";
import Tutorial from "../risk/Tutorial";
import AlertInfoBar from "../WeatherAlerts/AlertInfoBar";

export default function RiskViewer()
{
    // window size handler
    useWindowSize();

    //data derived from redux state
    const riskViewerState = useRiskViewerState();
    const forecastTime = useForecastTime();

    //data derived from queries to the backend
    const { routeMetadata } = useRouteMetadata();
    const { latestTime, isLatestError, latestSucceeded, refetchRiskData } = useLatestForecast( );

    // hook to handle fetching all data from the backend based on the current forecast time.
    const { components, isFetching, isError } = useFetchSurfaces( latestSucceeded, routeMetadata, refetchRiskData );

    //functions to check loading status of the page
    const dataStale = isDataStale( riskViewerState.kind, latestSucceeded, forecastTime, latestTime );

    return (
        <React.Fragment>
            <GeoView
                dataFetchFailed = {isLatestError}
                refetchRiskData = {refetchRiskData}
                components = {components}
            >
                <TripDrawerElement/>
                <UserProfileElement/>
            </GeoView>
            <Timeline
                dataIsStale = {dataStale ?? false}
                refetchRiskData = {refetchRiskData}
                routeStartTime = {
                    routeMetadata !== undefined ? routeMetadata?.startTime?.getTime() : undefined
                }
                routeEndTime = {
                    routeMetadata !== undefined ? routeMetadata?.endTime?.getTime() : undefined
                }
                isRiskError = {isError}
                isLoading = {isFetching}
            />
            <AlertInfoBar/>
            <Tutorial/>
            {/*<ChangelogPopup/>*/ /* Commenting this out till we can agree on wordage */}
        </React.Fragment>
    );
}
